import * as z from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

export const getHsaPaymentAnalytics = {
  name: "getHsaPaymentAnalytics" as const,
  input: z.object({ startDate: isoDate, endDate: isoDate }),
  output: z.object({
    series: z.array(
      z.object({ date: z.string(), orders: z.number(), grossUsd: z.number() }),
    ),
    totalOrders: z.number(),
    totalGrossUsd: z.number(),
    /** Merchants that returned data. */
    merchantsReporting: z.number(),
    /** All HSA-enabled merchants we attempted to query. */
    merchantsTotal: z.number(),
  }),
};
